import { render, staticRenderFns } from "./SongDeleteModal.vue?vue&type=template&id=397a7403&"
import script from "./SongDeleteModal.vue?vue&type=script&lang=js&"
export * from "./SongDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports